import React from 'react';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { makeStyles, Theme } from '@material-ui/core/styles';

import { COLOR_PRIMARY_DARK, COLOR_PRIMARY_LIGHT } from 'src/const';

const useStyles = makeStyles((theme: Theme) => ({
  button: {
    background: COLOR_PRIMARY_DARK,
    borderRadius: 5,
    border: 0,
    color: 'white',
    padding: '5px 30px',
    boxShadow: '0 1px 1px 1px rgba(255, 255, 255, .3)',
    '&:hover': {
      background: COLOR_PRIMARY_LIGHT,
    },
    fontSize: 16,
  },
}));

const ErrorDialog = ({
  open,
  setOpen,
  title,
  body,
}: {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  title: string;
  body: string;
}) => {
  const classes = useStyles();

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      disableEnforceFocus
    >
      <DialogTitle id="alert-dialog-title" sx={{ color: '#d32f2f' }}>
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description" sx={{ color: '#222' }}>
          {body}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button className={classes.button} onClick={handleClose}>
          I Understood
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ErrorDialog;
